import React from 'react'
import Layout from '../../components/help/Layout/Layout'
import Seo from '../../components/help/Seo'
import Header from '../../components/ui/Header/Header'
import Intro from '../../components/ui/Intro/Intro'
import Partnership from '../../components/pages/Partnership/Partnership'
import { getHrefToHome } from '../../utils/getHrefToHome'
import { graphql, useStaticQuery } from 'gatsby'

const Partnershipage = () => {
    const lang = 'hy'

    const hrefHome = getHrefToHome(lang)

    const data = useStaticQuery(graphql`
        {
            titleOne: datoCmsRenshinPagePartnership(title: { eq: "Block 1: Title" }, locale: { eq: "hy" }) {
                value
            }

            textOne: datoCmsRenshinPagePartnership(title: { eq: "Block 1: Text" }, locale: { eq: "hy" }) {
                value
            }

            emailOne: datoCmsRenshinPagePartnership(title: { eq: "Block 1: E-mail" }, locale: { eq: "hy" }) {
                value
            }

            titleTwo: datoCmsRenshinPagePartnership(title: { eq: "Block 2: Title" }, locale: { eq: "hy" }) {
                value
            }

            textTwo: datoCmsRenshinPagePartnership(title: { eq: "Block 2: Text" }, locale: { eq: "hy" }) {
                value
            }

            emailTwo: datoCmsRenshinPagePartnership(title: { eq: "Block 2: E-mail" }, locale: { eq: "hy" }) {
                value
            }
            
            preview: datoCmsRenshinPagePartnership(title: { eq: "Block 2: Image" }, locale: { eq: "en" }) {
                previewImage {
                    url
                }
            }

            titleSmall: datoCmsRenshinPagePartnership(title: { eq: "Title small" }, locale: { eq: "hy" }) {
                value
            }

            partnersSectionTitle: datoCmsRenshinPagePartnership(title: { eq: "Title small for partners list" }, locale: { eq: "hy" }) {
                value
            }

            partnersItems: allDatoCmsRenshinPartnership(sort: { fields: sorting, order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    name
                    text
                    photo {
                        url
                    }
                }
            }

            presentations: allDatoCmsRenshinPartnershipPresentationFile(sort: { fields: sorting, order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    name
                    file {
                        url
                        size
                        mimeType
                    }
                }
            }

            seo: datoCmsRenshinSeo(pageName: { eq: "Partnership" }, locale: { eq: "hy" }) {
                titleH1
                crumbsName
                bgDesktop {
                    url
                }
                bgTabletA {
                    url
                }
                bgTabletP {
                    url
                }

                bgMobile {
                    url
                }
                footerLinks {
                    title
                    url
                }
                seo {
                    title
                    description
                }
            }

            main: datoCmsRenshinSeo(pageName: { eq: "Main" }, locale: { eq: "hy" }) {
                crumbsName
            }
        }
    `)

    const photo = {
        1920: data.seo.bgDesktop.url,
        1440: data.seo.bgDesktop.url,
        1024: data.seo.bgTabletA?.url,
        768: data.seo.bgTabletP?.url,
        360: data.seo.bgMobile?.url
    }

    const breadCrumbs = [
        { name: `${data.main.crumbsName}`, href: `${hrefHome}`, current: false },
        { name: `${data.seo.crumbsName}`, current: true }
    ]

    return (
        <Layout lang={lang}>
            <Seo title={data.seo?.seo?.title} description={data.seo?.seo?.description} />
            <Header light lang={lang} />
            <Intro crumbs={breadCrumbs} title={`${data.seo.titleH1}`} photo={photo} lang={lang} />
            <Partnership data={data} lang={lang} />
        </Layout>
    )
}

export default Partnershipage
